import AsoHeader from "../../../components/Aso/Header";
import AsoValidarInfoNome from "../../../components/Aso/Register/AsoValidarInfoNome";

const AsoRegistroValidarInfoNome = () => {
    return(
        <>
            <AsoHeader />
            <AsoValidarInfoNome />
        </>
    );
}

export default AsoRegistroValidarInfoNome;